import { datadogLogs } from '@datadog/browser-logs';

export default class CardinalClient {
  constructor(store) {
    this.store = store;
  }

  initialize = () => {
    const client = window.Cardinal;
    const paymentFramework = process.env.REACT_APP_CARDINAL_PAYMENT_FRAMEWORK || 'inline';
    let cardinalWrapper;
    const { charge, fail, setPageLoading, source } = this.store;

    datadogLogs.logger.info('Cardinal config initialize', {
      data: { source_id: source.id }
    });

    client.configure({
      extendedtimeout: process.env.REACT_APP_CARDINAL_EXTENDED_TIMEOUT,
      maxRequestRetries: process.env.REACT_APP_CARDINAL_MAX_RETRIES,
      payment: {
        framework: paymentFramework,
        displayLoading: true,
        displayExitButton: true
      },
      timeout: process.env.REACT_APP_CARDINAL_TIMEOUT
    });

    client.setup('init', {
      jwt: source.redirect.auth_token
    });

    client.on('payments.setupComplete', function response() {
      datadogLogs.logger.info('Cardinal config setup complete', {
        data: { source_id: source.id }
      });

      client.continue(
        'cca',
        {
          AcsUrl: source.redirect.provider_auth_url,
          Payload: source.redirect.provider_auth_id
        },
        {
          OrderDetails: {
            TransactionId: source.redirect.provider_transaction_id,
            OrderNumber: source.redirect.reference_id
          }
        }
      );
    });

    client.on('ui.inline.setup', function inline(htmlTemplate, details, resolve, reject) {
      datadogLogs.logger.info('Cardinal 3DS page setup', {
        data: { source_id: source.id }
      });

      try {
        if (htmlTemplate !== undefined && details !== undefined) {
          switch (details.paymentType) {
            case 'CCA':
              switch (details.data.mode) {
                case 'static':
                  cardinalWrapper = document.getElementById('visible-wrapper');
                  break;
                case 'suppress':
                  cardinalWrapper = document.getElementById('hidden-wrapper');
                  break;
                default:
                  throw new Error(`Unsupported inline mode found [${details.data.mode}]`);
              }
              break;
            default:
              throw new Error(`Unsupported inline payment type found [${details.paymentType}]`);
          }
          cardinalWrapper.innerHTML = htmlTemplate;
          resolve();
        } else {
          throw new Error('Unable to process request due to invalid arguments');
        }
      } catch (error) {
        datadogLogs.logger.info('Cardinal 3DS page render error', {
          data: {
            error,
            source_id: source.id
          }
        });

        reject(error);
      }
    });

    client.on('ui.render', function render() {
      datadogLogs.logger.info('Cardinal 3DS page open', {
        data: { source_id: source.id }
      });

      setPageLoading(false);
    });

    client.on('payments.validated', function response(data, jwt) {
      // eslint-disable-next-line no-param-reassign
      data.source_id = source.id;

      datadogLogs.logger.info('Cardinal 3DS page close', { data });

      if (cardinalWrapper) cardinalWrapper.innerHTML = '';
      setPageLoading(true);

      const result = {
        auth_token_response: jwt,
        error_code: data.ErrorNumber,
        error_description: data.ErrorDescription
      };

      switch (data.ErrorNumber) {
        case 0:
          charge(result);
          break;
        default:
          fail(result);
          break;
      }
    });
  };
}
